module.exports = __webpack_public_path__ + "assets/6d3cba184a662c3e206176aee39e7b36.png";